module.exports = __webpack_public_path__ + "img/aspNet.4f7ba47a.svg";